<template>
  <div :class="{'has-navbar-fixed-top': UserId > 0}">

    <nprogress-container></nprogress-container>
    <div class="loader" v-if="loading" style="z-index: 1000"></div>
    <div v-if="Config != null && UserId > 0">
      <navbar v-show="true"></navbar>
      <sidebar v-show="sidebar.opened && !sidebar.hidden"></sidebar>
      <app-main></app-main>
    </div>

    <section v-if="Config != null && UserId == 0" class="hero is-primary is-fullheight">
      <div class="hero-body" style="padding-top:1rem">
        <div class="container has-text-centered">
          <div class="column is-4 is-offset-4">
            <div class="box">
              <figure class="avatar" style="margin-bottom:2rem">
                <img src="./assets/volleyball.svg" style="height:4rem"><br>
                <span class="titlefirst">Volley</span><span class="titlesecond">Admin3</span>
              </figure>
              <form>
                <div class="field">
                  <div class="control">
                    <input class="input is-large" placeholder="Username" autofocus="" ref="username" v-model="username">
                  </div>
                </div>
                <div class="field">
                  <div class="control">
                    <input class="input is-large" type="password" placeholder="Password" v-model="password">
                  </div>
                </div>
                <div class="field" v-if="Message">
                  <span class="has-text-danger">
                  {{Message}}
                  </span>
                  <span>
                    &nbsp;
                  </span>
                </div>
                <button class="button is-block is-info is-large is-fullwidth" @click.stop.prevent="DoLogin(true)">Login
                </button>
                <br>
                <span v-if="this.browsertype!== 'Google Chrome or Chromium' && this.browsertype !== 'Microsoft Edge'"
                      class="has-text-warning">
                  You are using {{this.browsertype}} as your browser. Please note that this browser is not supported by the VolleyAdmin3 web application.
                </span>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
  import NprogressContainer from 'vue-nprogress/src/NprogressContainer'
  import Navbar from './components/layout/Navbar.vue'
  import Sidebar from './components/layout/Sidebar.vue'
  import AppMain from './components/layout/AppMain.vue'
  import {mapGetters, mapActions} from 'vuex'
  import axios from 'axios'
  import {NotifierBus} from './store/eventbusses.js'
  import ProvinceMenu from './store/menu/province.js'
  import ClubMenu from './store/menu/club.js'

  export default {
    name: 'App',
    components: {
      NprogressContainer,
      Navbar,
      Sidebar,
      AppMain
    },
    props: {
      vcolor: {
        type: String,
        default: '#0000AA'
      }
    },
    data () {
      return {
        username: '',
        password: '',
        browsertype: '',
        loading: false
      }
    },
    computed: {
      ...mapGetters({sidebar: 'sidebar'}),
      ...mapGetters('security', ['UserId', 'Message', 'Provinces', 'HasProvincePermission', 'Clubs', 'HasClubPermission']),
      ...mapGetters('configuration', ['Config']),
      ...mapGetters(['vaconfig'])
    },
    beforeMount () {
      const {body} = document
      const WIDTH = 768
      const RATIO = 3

      const handler = () => {
        if (!document.hidden) {
          let rect = body.getBoundingClientRect()
          let isMobile = rect.width - RATIO < WIDTH
          this.toggleDevice(isMobile ? 'mobile' : 'other')
          this.toggleSidebar(!isMobile)
        }
      }
      document.addEventListener('visibilitychange', handler)
      window.addEventListener('DOMContentLoaded', handler)
      window.addEventListener('resize', handler)
      this.LoadVaConfig().then(() => {
        var requirements = [
          this.ConfigRequirement()
        ]
        requirements.reduce((p, fn) => p.then(fn), Promise.resolve())
        this.DoLogin(false)
      }).catch((err) => {
        console.log(err)
      })
    },

    created () {
      var sUsrAg = navigator.userAgent
      var sBrowser
      if (sUsrAg.indexOf('Firefox') > -1) {
        sBrowser = 'Mozilla Firefox'
      } else if (sUsrAg.indexOf('Opera') > -1 || sUsrAg.indexOf('OPR') > -1) {
        sBrowser = 'Opera'
      } else if (sUsrAg.indexOf('Trident') > -1) {
        sBrowser = 'Microsoft Internet Explorer'
      } else if (sUsrAg.indexOf('Edge') > -1) {
        sBrowser = 'Microsoft Edge'
      } else if (sUsrAg.indexOf('Chrome') > -1) {
        sBrowser = 'Google Chrome or Chromium'
      } else if (sUsrAg.indexOf('Safari') > -1) {
        sBrowser = 'Apple Safari'
      } else {
        sBrowser = 'An unknown browser'
      }
      this.browsertype = sBrowser

      axios.interceptors.request.use((config) => {
        this.loading = true
        return config
      }, (error) => {
        this.loading = false
        NotifierBus.$emit('Notify', {type: 'danger', title: 'Server Error', message: error, duration: 0})
        return Promise.reject(error)
      })

      axios.interceptors.response.use((response) => {
        this.loading = false
        return response
      }, (error) => {
        this.loading = false
        if (error.response.status === 401) {
          NotifierBus.$emit('Notify', {
            type: 'danger',
            title: error.response.statusText,
            message: error.response.request.responseURL,
            duration: 0
          })
        }
        return Promise.reject(error)
      })
    },
    methods: {
      ...mapActions([
        'toggleDevice',
        'toggleSidebar',
        'LoadVaConfig'
      ]),
      ...mapActions('configuration', ['ConfigRequirement']),
      ...mapActions('security', ['Login']),
      ...mapActions('menu', ['AddItemToMenu']),
      DoLogin (withparams) {
        this.Login(withparams ? {username: this.username, password: this.password} : null).then(function () {
          for (var provid in this.Provinces) {
            let prov = this.Provinces[provid]
            let m = JSON.parse(JSON.stringify(ProvinceMenu))
            m.meta.label = prov.province_name
            m.params = {province_id: prov.province_id}
            m.hidden = false
            m.createroutes = false
            m.children.forEach((child) => {
              child.params = m.params
            })
            m.children = m.children.filter((item) => {
              return !item.meta.permission || this.HasProvincePermission(prov.province_id, item.meta.permission)
            })
            this.AddItemToMenu(m)
          }
          for (var clubid in this.Clubs) {
            let club = this.Clubs[clubid]
            let m = JSON.parse(JSON.stringify(ClubMenu))
            m.meta.label = club.club_name
            m.params = {club_id: club.club_id}
            m.hidden = false
            m.createroutes = false
            m.children.forEach((child) => {
              child.params = m.params
            })
            m.children = m.children.filter((item) => {
              return !item.meta.permission || this.HasClubPermission(club.club_id, item.meta.permission)
            })
            this.AddItemToMenu(m)
          }
        }.bind(this))
        this.password = ''
      }
    }
  }
</script>

<style lang="scss">
  @import '~@mdi/font/css/materialdesignicons.css';

  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
  }

  .titlefirst {
    font-weight: bold;
    font-size: 3rem;
    margin-left: 10px;
    color: #006573;
  }

  .titlesecond {
    font-weight: bold;
    font-size: 3rem;
    color: #28374B;
  }

  .loader {
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 100;
    width: 50px;
    height: 50px;
    margin: -75px 0 0 -75px;
    border: 4px solid #cccccc;
    border-radius: 50%;
    border-top: 4px solid #00af9b;
    -webkit-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
  }

  @-webkit-keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
    }
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

</style>



// WEBPACK FOOTER //
// App.vue?48e98156